export default {
    langslabs(state) { return state.langslabs;},      
	access_slabs(state) {return state.slabs;},
    get_slabsStorage(state) { return state.slabsStorage;},	    
}
